import { render } from "./VerificationCodeField.vue?vue&type=template&id=c154f14c&scoped=true&ts=true"
import script from "./VerificationCodeField.vue?vue&type=script&lang=ts"
export * from "./VerificationCodeField.vue?vue&type=script&lang=ts"

import "./VerificationCodeField.vue?vue&type=style&index=0&id=c154f14c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c154f14c"]])

export default __exports__